/*side search*/
var ck = ck || {};

(function ($) {

  $(function () {

    //onReady set side search as top of indexed tab order
    let _tabcount = 0;
    $('.ckExpand:not(:hidden) input, .ckExpand:not(:hidden) select').each(function (i, el) {
      _tabcount++;
      $(el).attr('tabindex', +_tabcount);
    });
    processColorChange(); //set existing card color ui
  });

  let processSideSearchTouch = _.throttle(function (e) {
    let $parent = $(e.target).parents('.ckExpand');
    if ($(e.target).hasClass('ckTooltip')) {
      $('.ckTooltip').css({'display': 'none'});
    } else if (!$(e.target).hasClass('ckHelp')) {
      $parent.toggleClass('open');
    }
  }, 300, {leading: false, trailing: true});

  let processResize = _.throttle(function (e) {
    if($('body').outerWidth() <= 1200) {
      let sidesearchHeight = $(window).height() - $('.header').height();
      $('body #search.sidesearch').css({'height': sidesearchHeight}); //set height for mobile scroll
    } else {
      $('body #search.sidesearch').css({'height': 'auto'});
    }
  });

  let processColorChange = function(){
    let colorsSelected = $('.includeColors.cardColor input:checked').length;
    if(colorsSelected > 0) {
      $('#colorContainer').addClass('colorIsSet');
    } else {
      $('#colorContainer').removeClass('colorIsSet');
      //clear the count includes
      $('.includeCount input').each(function(index,el){
        $(el).prop("checked", false);
      });
    }
  };

  $(window).on('resize', function () { //move to debounce
    processResize();
  });
  processResize();

  $(document).on('touchend click', '#search.sidesearch .ckExpand:not(".alwaysOpen") .title', function (e) {
    processSideSearchTouch(e);
  });

  //open collapsed element on tab focus
  $(document).on('focus', '.ckExpand input, .ckExpand select', function (e) {
    let $parent = $(this).parents('.ckExpand');
    $parent.addClass('open');
  });

  //tooltip event override on touchstart
  $(document).on('touchstart', '#search', function (e) {
    if (!$(e.target).hasClass('ckHelp')) {
      $('.ckTooltip').css({'display': 'none'});
    }
  });
  //toggle mobile advanced search menu
  $(document).on('click','.sliderTabToggle',function(){ $(this).parent().toggleClass('open'); });

  $(document).on('click', '#sideSearchExpandAll', function (e) {
    e.preventDefault();
    if ($(this).data('expand') === 'all') {
      $('.sidesearch .filterHeader.ckExpand:not(.alwaysOpen)').removeClass('open');
      $(this).data('expand', '').text('Expand All');
    } else {
      $('.sidesearch .filterHeader.ckExpand').addClass('open');
      $(this).data('expand', 'all').text('Collapse All (-)');
    }
  });

  //set filterTypeValue checkbox checked if text input on optional filterTypeValue is set
  $(document).on('input', '#filterTypeInput', function (e) {
    //set checkbox
    let _val = this.value;
    if (_val.length > 0) {
      $('#filterTypeValue').prop('checked', true);
    } else {
      $('#filterTypeValue').prop('checked', false);
    }
  });

  //listen of change to add apply button
  $(document).on('change keyup', '#search *', function (e) {
    let $item = $(this);
    let $parent = $item.parents('.filterHeader');
    if ($item.hasClass('editionToggle') || $parent.hasClass('editionToggle') || $item.hasClass('formatToggle') || $parent.hasClass('formatToggle')) {
      $('#search').submit();
    } else {
      $item.addClass('edited');
      setTimeout(function () {
        $item.find('.sideSearchApply').css('opacity', 1);
      }, 0);
    }
  });

  //display card color count if color is set
  $(document).on('change','.includeColors input',function(e){
    processColorChange();
  });


})(jQuery);